import { render } from "./csdbsStats.vue?vue&type=template&id=3543fff5&scoped=true"
import script from "./csdbsStats.vue?vue&type=script&lang=js"
export * from "./csdbsStats.vue?vue&type=script&lang=js"

import "./csdbsStats.vue?vue&type=style&index=0&id=3543fff5&scoped=true&lang=css"

import exportComponent from "/Users/berkuralcan/Documents/dev/webdev/dansuk-engineering-dashboard-v3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3543fff5"]])

export default __exports__